import {tokenAxiosInstance} from "../../utils/token.axios.instance";

export const getUserInfo = async () => {
  const axios = tokenAxiosInstance();
  const { data } = await axios.get('/user-manager-bff/api/users/token')
  return data;
}